import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import './styles.scss';

import Lx from './Lx';
import Ly from './Ly';
import Dpp from './Dpp';
import Dpl from './Dpl';
import Lyh from './Lyh';
import Tfix from './Tfix';
import Spacing from './Spacing';
import EdgeDistance from './EdgeDistance';

import Application from '../../../Application';
import SafetyBarrierObject from '../../../../object-view/generators/safety-barrier/safety-barrier.object';
import { APP_TEXTS } from '../../../../texts/texts';

import PositionsTable from '@components/PositionsTable/PositionsTable';
import Panel from '@scene/objects/panel';
import * as THREE from 'three';
import ObjectView from '@scene/views/object-view';
import { setMode } from '@reducers/actions';

class BasePlate extends Component {

  static propTypes = {
    type: PropTypes.string.isRequired,
    options: PropTypes.shape()
  };

  state = {
    isScrewTab: false
  };

  render() {
    return (
      <div className="calculation base-plate" aria-disabled="true">
        <section className="list-type">
          <h4>{APP_TEXTS.BASE_PLATE_DIMENSION_LABEL.Content}</h4>

          <div className="base-plate__row_inline">
            <div className="base-plate__row">
              <Lx />
              <Ly />
              <Dpp />
              <Dpl />
              <Lyh />
            </div>
          </div>
        </section>

        <section className="list-type">
          <h4>{APP_TEXTS.BASE_PLATE_THICKNESS_LABEL.Content}</h4>

          <Tfix />
        </section>

        {(!this.props.isScrewCustomLayout && !this.props.isPanelCustomLayout) && (
        <section className="list-type">
          <h4>{APP_TEXTS.BASE_PLATE_SPACING_LABEL.Content}</h4>

          <Spacing />
        </section>
        )}
        {(this.props.isScrewCustomLayout || this.props.isPanelCustomLayout) && (
          <React.Fragment>
            <section className="list-type">
              <div className="btn-group w-100">
                <button
                  className={`btn ${!this.state.isScrewTab && 'ToggleButton--active'}`}
                  name="combined"
                  onClick={() => this.switchToScrewTab(false)}>
                  {APP_TEXTS.PANEL_VERTICES.Content}
                </button>
                <button
                  className={`btn ${this.state.isScrewTab && 'ToggleButton--active'}`}
                  name="design"
                  onClick={() => this.switchToScrewTab(true)}>
                  {APP_TEXTS.SCREW_POSITIONS.Content}
                </button>
                <button
                  className="btn btn-light ImageButton--active col-2" 
                  onClick={() => {
                    this.props.display2DEditor();
                  }}
                >
                  <span className="icon_editor" />
                </button>
              </div>
            </section>
            <div>
              <section className="list-type">
                {this.state.isScrewTab ? (
                  <div className="w-50">
                    <h4 className="text-center">{APP_TEXTS.SCREW_POSITIONS.Content}</h4>

                    <PositionsTable positions={this.props.screwPositions} isDisabled={true} />
                  </div>
                ) : (
                  <div className="w-50">
                    <h4 className="text-center">{APP_TEXTS.PANEL_VERTICES.Content}</h4>
      
                    <PositionsTable positions={this.props.panelVertices} isDisabled={true} />
                  </div>

                )}
              </section>
            </div>
          </React.Fragment>
        )}

        {this.isEdgeDistance && (
          <section className="list-type">
            <h4>{APP_TEXTS.BASE_PLATE_EDGE_DISTANCE_LABEL.Content}</h4>

            <EdgeDistance />
          </section>
        )}
      </div>
    );
  }

  get isEdgeDistance() {
    return (
      !this.props.isScrewCustomLayout &&
      (this.props.type === Application.types.GENERAL_CALCULATION ||
        (this.props.type === Application.types.SAFETY_BARRIER &&
          this.props.options.object.type === SafetyBarrierObject.types.FLOOR_SLAB) ||
        ((this.props.options.object.type === SafetyBarrierObject.types.STAIRS &&
          !this.props.options.panel.disableEdgeDistance) ||
          this.props.options.object.type === SafetyBarrierObject.types.BETWEEN_WALLS))
    );
  }

  switchToScrewTab(changeToScrew) {
    this.setState({
      isScrewTab: changeToScrew
    });
  }

}

const mapState = state => {
  var screwPositions = [], panelVertices = [];
  if (state.options.screw.coordinatesList)
    screwPositions = state.options.screw.coordinatesList.map(pos => new THREE.Vector3(pos.x, pos.y * -1, pos.z * -1));
  if (state.options.panel.vertices)
    panelVertices = state.options.panel.vertices.positions.map(pos => new THREE.Vector3(pos.x, pos.y * -1, pos.z));

  return {
    type: state.main.appType,
    options: state.options,
    isScrewCustomLayout: state.options.screw.customLayout,
    isPanelCustomLayout: state.options.panel.type === Panel.types.CUSTOM,
  
    screwPositions: screwPositions,
    panelVertices: panelVertices
  };
};

const mapDispatch = dispatch => ({
  display2DEditor: () => {
    dispatch(setMode(ObjectView.mode.MODE_2D_EDITOR));
  }
});

export default connect(mapState, mapDispatch)(BasePlate);



// WEBPACK FOOTER //
// ./src/views/Dimension/components/BasePlate/index.js